"use strict";var index=require("../getParameters/index.js"),getUrlParameter=e=>{var r;return window&&window.location?(r=window.location.search,index(e,/[?&]?([^=]+)=([^&]*)/g,r)):null};
/** Получить значение/значения URL-параметра по имени
 *
 * @param {string} name - имя URL-параметра
 * @returns {string|string[]} значение URL-параметра или несколько значений в виде массива
*/module.exports=getUrlParameter;
